'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _pick2 = require('lodash/pick');
var _pick3 = _interopRequireDefault(_pick2);
var _isEqual2 = require('lodash/isEqual');
var _isEqual3 = _interopRequireDefault(_isEqual2);
var _get2 = require('lodash/get');
var _get3 = _interopRequireDefault(_get2);
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _reactFinalForm = require('react-final-form');
var _immutable = require('immutable');
var _immutable2 = _interopRequireDefault(_immutable);
var _recompose = require('recompose');
var _savvySwift = require('@energysavvy/savvy-swift');
var _propTypes3 = require('../utils/propTypes');
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _objectWithoutProperties(obj, keys) {
  var target = {};
  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }
  return target;
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var answersPropType = _propTypes2.default.objectOf(_propTypes2.default.oneOfType([_propTypes2.default.string.isRequired, _propTypes2.default.number.isRequired]));
function filterChoiceQuestionsWithInvalidValues(questions, answers) {
  return questions.filter(function (question) {
    if (!question.choices) {
      return false;
    }
    return Object.entries(answers).some(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
        questionSlug = _ref2[0],
        answer = _ref2[1];
      return question.slug === questionSlug && !question.choices.includes(answer);
    });
  });
}
function transformQuestionForSwift(question) {
  var mappedQuestion = _extends({
    global_slug: question.slug
  }, question);
  if (question.choice_labels) {
    mappedQuestion.choices = question.choice_labels.map(function (choice) {
      return choice.slug;
    });
  }
  return mappedQuestion;
}
function transformMetaForSwift(questions) {
  return questions.map(transformQuestionForSwift);
}
function selectQuestionsHaveChanged(questions, previousAnswers, nextAnswers) {
  var keys = questions.filter(function (question) {
    return question.question_type === 'select';
  }).map(function (question) {
    return question.slug;
  });
  return !(0, _isEqual3.default)((0, _pick3.default)(previousAnswers, keys), (0, _pick3.default)(nextAnswers, keys));
}
function withCalculatedQuestions(Component) {
  var FormQuestionsCalculator = function (_React$Component) {
    _inherits(FormQuestionsCalculator, _React$Component);
    function FormQuestionsCalculator(props) {
      _classCallCheck(this, FormQuestionsCalculator);

      // When a question unmounts, it should remove its value
      // See https://github.com/final-form/final-form/#destroyonunregister-boolean
      var _this = _possibleConstructorReturn(this, (FormQuestionsCalculator.__proto__ || Object.getPrototypeOf(FormQuestionsCalculator)).call(this, props));
      _this.props.form.setConfig('destroyOnUnregister', true);
      var trimmer = new _savvySwift.Trimmer(_immutable2.default.fromJS(props.path), _immutable2.default.fromJS(transformMetaForSwift(props.questions)));
      var mergedValues = _this.mergeCalculatedAnswers(props.initialValues);
      var initialAnswers = _immutable2.default.fromJS(mergedValues);
      var questions = trimmer.reconstructQuestions(initialAnswers).toJS();
      _this.state = {
        trimmer: trimmer,
        questions: questions,
        answers: props.initialValues
      };
      _this.onChange = _this.onChange.bind(_this);
      _this.props.form.setConfig('mutators', {
        clearInvalidValues: _this.clearInvalidValues
      });
      return _this;
    }
    _createClass(FormQuestionsCalculator, [{
      key: 'onChange',
      value: function onChange(form) {
        if (!selectQuestionsHaveChanged(this.props.questions, this.state.answers, form.values)) {
          // The select questions have the same value, no need to run swift
          return;
        }
        var mergedValues = this.mergeCalculatedAnswers(form.values);
        var questions = this.state.trimmer.reconstructQuestions(_immutable2.default.fromJS(mergedValues)).toJS();
        var filteredquestionsWithInvalidValues = filterChoiceQuestionsWithInvalidValues(questions, form.values);
        if (filteredquestionsWithInvalidValues) {
          this.props.form.mutators.clearInvalidValues(filteredquestionsWithInvalidValues);
        }
        this.setState({
          questions: questions,
          answers: form.values
        });
      }
    }, {
      key: 'render',
      value: function render() {
        var _props = this.props,
          questions = _props.questions,
          children = _props.children,
          otherProps = _objectWithoutProperties(_props, ['questions', 'children']);
        return _react2.default.createElement(Component, _extends({
          questions: this.state.questions
        }, otherProps), _react2.default.createElement(_reactFinalForm.FormSpy, {
          subscription: {
            values: true
          },
          onChange: this.onChange
        }), children);
      }
    }, {
      key: 'mergeCalculatedAnswers',
      value: function mergeCalculatedAnswers(answers) {
        return _extends({}, this.props.calculatedAnswers, answers);
      }
    }, {
      key: 'clearInvalidValues',
      value: function clearInvalidValues(_ref3, state, _ref4) {
        var _ref5 = _slicedToArray(_ref3, 1),
          questions = _ref5[0];
        var changeValue = _ref4.changeValue;
        questions.forEach(function (question) {
          changeValue(state, question.slug, function () {
            return undefined;
          });
        });
      }
    }]);
    return FormQuestionsCalculator;
  }(_react2.default.Component);
  FormQuestionsCalculator.propTypes = {
    questions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
      slug: _propTypes2.default.string.isRequired,
      question_type: _propTypes2.default.string.isRequired,
      choice_labels: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        slug: _propTypes2.default.string.isRequired
      }).isRequired)
    })),
    path: _propTypes2.default.shape({
      conditions: _propTypes2.default.arrayOf(_propTypes2.default.shape({
        dependents: _propTypes2.default.arrayOf(_propTypes2.default.oneOfType([_propTypes2.default.string.isRequired, (0, _propTypes3.arrayOfShape)([_propTypes2.default.string.isRequired,
        // Question slug
        _propTypes2.default.string] // Answer
        )])),

        options: _propTypes2.default.arrayOf((0, _propTypes3.arrayOfShape)([_propTypes2.default.string.isRequired,
        // Question slug
        _propTypes2.default.string] // Answer
        )),

        type: _propTypes2.default.oneOf(['Any', 'All'])
      })),
      questions: _propTypes2.default.objectOf(_propTypes2.default.arrayOf(_propTypes2.default.string.isRequired).isRequired).isRequired
    }).isRequired,
    form: _propTypes2.default.shape({
      mutators: _propTypes2.default.shape({
        clearInvalidValues: _propTypes2.default.func
      }),
      setConfig: _propTypes2.default.func.isRequired
    }).isRequired,
    initialValues: answersPropType,
    calculatedAnswers: answersPropType,
    children: _propTypes2.default.node
  };
  FormQuestionsCalculator.displayName = 'withCalculatedQuestions(' + (0, _recompose.getDisplayName)(Component) + ')';
  return FormQuestionsCalculator;
}

// Avoiding running swift if there is no path, or if there are no conditions to run against
exports.default = (0, _recompose.branch)(function (props) {
  return (0, _get3.default)(props, 'path.conditions', []).length > 0;
}, withCalculatedQuestions);